(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/form-action/assets/javascripts/form-action.js') >= 0) return;  svs.modules.push('/components/components/form-action/assets/javascripts/form-action.js'); 
$(function() {
  'use strict';

  svs.components.formAction = svs.components.formAction || {};

  svs.components.formAction.handleKey = function(inputField, type) {
    var element = $(inputField).parent(),
      inputAction = $(inputField).siblings('.js-input-action'),
      input = $(inputAction).siblings('.js-input'),
      iconOn = '',
      iconOff = '',
      icon = '',
      iconSearch = $(inputAction).siblings('.search-icon');

    if (!inputAction.hasClass('icon-default')) {
      inputAction.addClass('icon-default');
    }

    if (element.hasClass('js-input-action-show-password')) {
      iconOn = 'icon-eye';
      iconOff = 'icon-eye-closed';
      icon = input.attr('type') === 'password' ? iconOn : iconOff;
    }

    if (element.hasClass('js-input-action-reset')) {
      icon = iconOn = 'icon-remove-sign';
    }

    if (inputField.val().length > 0) {
      if (type === 'blur') {
        inputAction.removeClass(icon);
        inputAction.hide();

        if (iconSearch) {
          iconSearch.show();
        }
      } else {
        inputAction.addClass(icon);
        inputAction.show();

        if (type === 'focus' && iconSearch) {
          iconSearch.hide();
        }
      }
    } else {
      inputAction.hide();
      inputAction.removeClass(iconOn);
      inputAction.removeClass(iconOff);

      if (iconSearch) {
        if (type === 'focus') {
          iconSearch.hide();
        } else if (type === 'blur') {
          iconSearch.show();
        }
      }
    }
  };

  svs.components.formAction.handleClick = function(inputAction) {
    var element = $(inputAction).parent('.has-input-action'),
      input = $(inputAction).siblings('.js-input');

    if (
      element.hasClass('js-input-action-show-password') &&
      input.val().length > 0
    ) {
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
        inputAction.addClass('icon-eye-closed');
        inputAction.removeClass('icon-eye');
      } else {
        input.attr('type', 'password');
        inputAction.removeClass('icon-eye-closed');
        inputAction.addClass('icon-eye');
      }
    }

    if (element.hasClass('js-input-action-reset')) {
      if (input.val() !== '') {
        input.val('');
        input.trigger('input');
      }

      inputAction.hide();
    }
  };

  $(document).on('keyup', '.has-input-action .js-input', function() {
    svs.components.formAction.handleKey($(this), 'keyup');
  });

  $(document).on('focus', '.has-input-action .js-input', function(e) {
    svs.components.formAction.handleKey($(this), 'focus');
    e.preventDefault();
  });

  $(document).on('blur', '.has-input-action .js-input', function() {
    svs.components.formAction.handleKey($(this), 'blur');
  });

  $(document).on('click', '.js-input-action', function() {
    svs.components.formAction.handleClick($(this));
  });

  $(document).on('click', '.search-icon', function() {
    var input = $(this).siblings('.js-input');
    input.focus();
  });

  $(document).on('mousedown', '.js-input-action', function(e) {
    e.preventDefault();
  });
});

 })(window);